<template>
  <validation-observer ref="refFormObserver">
    <b-form>
      <b-row v-if="itemData.config">
        <b-col
          cols="4"
          v-for="(config, index) in itemData.config"
          md="4"
          :key="index">
          <b-form-group
            class="text-capitalize"
            :label="index"
            :label-for="index">
            <b-form-input
              :id="index"
              v-model.number="itemData.config[index]"
              trim
              type="number"
              :min="0"
              :placeholder="index"
              @input="value => itemData.config[index] = Number(value)"
              v-if="typeof config === 'number'"
            />

            <b-form-input
              :id="index"
              v-model="itemData.config[index]"
              trim
              :placeholder="index"
              v-if="typeof config === 'string' || typeof config === 'null'"
            />

            <b-form-checkbox
              :id="index"
              v-model="itemData.config[index]"
              :name="index"
              :value="true"
              class="my-1 text-capitalize"
              :unchecked-value="false"
              v-if="typeof config === 'boolean'"
              switch>
              {{ index }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>
  
<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";
import SelectPaginate from "@/views/components/SelectPaginate.vue";
import { ref, watch } from "@vue/composition-api";
import axios from "@axios";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    SelectPaginate,
  },
  props: {
    propItemData: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    isAdd: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { refFormObserver, getValidationState } = formValidation();
    const itemData = ref(JSON.parse(JSON.stringify(props.propItemData)));
    const getPathConfig = async () => {
      if (itemData.value.config === null) {
        const params = {
          id_proxy_rtsp_server: itemData.value.id_proxy_rtsp_server,
          path: itemData.value.path,
        }
        const {data} = await axios.get(`/v1/generic-device/get-path-config`, {params});
  
        if (data.success) {
          const cleaned = Object.fromEntries(
            Object.entries(data.data).filter(
              ([key]) => !['source', 'sourceOnDemand'].includes(key) && 
                !key.startsWith('rpi') && !key.startsWith('record') && !key.startsWith('name')
            )
          );
          itemData.value.config = cleaned
        }
      }
    };

    getPathConfig()

    const validateStep = () => {
      return refFormObserver.value.validate();
    };

    watch(
      () => itemData,
      (newValue) => {
        emit("update:itemData", { ['config']: newValue.value.config });
      },
      { deep: true }
    );

    return {
      validateStep,
      itemData
    };
  },
};
</script>
